import React from "react";
import {BrowserRouter as Router,Routes,Route,Navigate,} from "react-router-dom";
import "./assets/css/font/fontStyles.css";
import "./App.css";

/* CUSTOMER */
import Home from "./screens/customer/homeScreen/Home";
import About from "./screens/customer/about/About";
import Treatments from "./screens/customer/treatments/Treaments";
import ContactSection from "./screens/customer/contactScreen/ContactSection";
import DealsPage from "./screens/customer/deals/DealsPage";
import DealsDetailPage from "./screens/customer/deals/DealsDetailPage";
import Blog from "./screens/customer/blogScreen/Blog";
import BlogDetailPage from "./screens/customer/blogScreen/BlogDetailPage";
import TreatmentsDetail from "./screens/customer/treatments/TreatmentsDetail";
import TermsOfService from "./components/legalpages/TremsOfService";
import PrivacyPolicy from "./components/legalpages/PrivacyPolicy";
import MyTreatmentDetail from "./screens/customer/dashboard/MyTreatmentDetail";

/* ===== CUSTOMER Dashboard ===== */
import CustomerLogin from "./screens/customer/auth/CustomerLogin";
import CustomerRegister from "./screens/customer/auth/CustomerRegister";

/* ===== CUSTOMER DASHBOARD ===== */
import CustomerLayout from "./layouts/customer/CustomerLayout";
import CustomerDashboard from "./screens/customer/dashboard/CustomerDashboard";
import MyAppointments from "./screens/customer/dashboard/MyAppointments";
import BookNewAppointment from "./screens/customer/dashboard/BookNewAppointment";
import MyTreatments from "./screens/customer/dashboard/MyTreatments";
import Deals from "./screens/customer/dashboard/Deals";
import CustomerBlog from "./screens/customer/dashboard/CustomerBlog";
import Notifications from "./screens/customer/customernotifications/Notifications";
import Profile from "./screens/customer/customerprofile/Profile";
import CustomerSupport from "./screens/customer/dashboard/Support";
import MyDeals from "./screens/customer/dashboard/MyDeals";
/* ===== ADMIN ===== */
import AdminAuth from "./screens/admin/auth/AdminAuth";
import AdminDashboard from "./screens/admin/dashboard/AdminDashboard";
import SubAdmin from './screens/admin/dashboard/subadmin/SubAdmin';
import Escategories from "./screens/admin/dashboard/Escategories/Escategories";
import AdminTreatments from "./screens/admin/dashboard/treatments/AdminTreatments";
import AdminAppointments from "./screens/admin/dashboard/appointments/AdminAppointments";
import AdminDeals from "./screens/admin/dashboard/deals/AdminDeals";
import AdminBlogs from "./screens/admin/dashboard/Ablogs/AdminBlogs";
import AdminSupport from "./screens/admin/dashboard/adminsupport/AdminSupport";
import AdminProfile from './screens/admin/dashboard/adminprofile/AdminProfile';
import AdminNotifications from "./screens/admin/dashboard/adminnotifications/AdminNotifications";
import AdminAIContent from "./screens/admin/dashboard/aiContent/AdminAIContent";
function App() {
  return (
   
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/treatments" element={<Treatments />} />
          <Route path="/treatment-details" element={<TreatmentsDetail />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deal-details" element={<DealsDetailPage />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blog-detailpage" element={<BlogDetailPage/>}/>
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
          

        {/* ===== CUSTOMER AUTH ===== */}
        <Route path="/customer/login" element={<CustomerLogin />} />
        <Route path="/customer/register" element={<CustomerRegister />} />

        {/* ===== CUSTOMER PANEL ===== */}
        <Route
          path="/customer"
          element={<CustomerLayout customerName="Aisha" notificationCount={2} />}
        >
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<CustomerDashboard />} />
          <Route path="appointments" element={<MyAppointments />} />
          <Route path="book" element={<BookNewAppointment />} />
          <Route path="treatments" element={<MyTreatments />} />
          <Route path="/customer/treatments/:id" element={<MyTreatmentDetail />} />
          <Route path="deals" element={<Deals />} />
          <Route path="blog" element={<CustomerBlog />} />
          <Route path="support" element={<CustomerSupport />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="profile" element={<Profile />} />
          <Route path="my-deals" element={<MyDeals />} />
          <Route path="contact" element={<ContactSection />} />
       
        </Route>

        {/* ===== ADMIN ===== */}
        <Route path="/adminlogin" element={<AdminAuth />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/treatments" element={<AdminTreatments />} />
        <Route path="/admin/categories" element={<Escategories />} />
        <Route path="/admin/appointments" element={<AdminAppointments />} />
        <Route path="/admin/deals" element={<AdminDeals />} />
        <Route path="/admin/blogs" element={<AdminBlogs />} />
        <Route path="/admin/support" element={<AdminSupport />} />
        <Route path="/admin/subadmins" element={<SubAdmin />} />
        <Route path="/admin/profile" element={<AdminProfile/>} />
        <Route path="/admin/notifications"element={<AdminNotifications />}/>
        <Route path="/admin/ai-content"element={<AdminAIContent />}
/>
      </Routes>

  );
}

export default App;